/**
 * PLACEHOLDER consent copy (spec D6). The version id pins the exact copy shown
 * at grant time and travels to the server as `consentVersion`; it MUST match
 * the BE resources file (QLearn-service
 * src/main/resources/sdl-consent/<version>.en.json).
 *
 * The customer-facing copy is a legally-flavored text and is OWNER-GATED:
 * route the owner-decision-packet and supersede this module (new version id,
 * both repos) before any customer-visible flip. Building against placeholder
 * copy is the spec's explicit instruction — the surface does not wait on the
 * ratified copy, the flip does.
 */
export const SDL_CONSENT_COPY_VERSION = "sdl-consent-copy-v0-placeholder";

export const sdlConsentCopy = {
  standingTitle: "[PLACEHOLDER] Session-derived study material",
  standingBody:
    "[PLACEHOLDER] When enabled, QLearn creates study notes and practice " +
    "questions from your tutoring sessions. Personal information is scrubbed. " +
    "You can revoke any session's consent later, which deletes the material " +
    "derived from it.",
  interstitialTitle: "[PLACEHOLDER] Use this session for study material?",
  interstitialBody:
    "[PLACEHOLDER] QLearn can turn this session into study notes and practice " +
    "questions for you. Personal information is scrubbed. Declining never " +
    "affects your session.",
  scopeTranscriptOnly: "[PLACEHOLDER] Transcript only",
  scopeAudioAndTranscript: "[PLACEHOLDER] Audio and transcript",
  revokeConfirm:
    "[PLACEHOLDER] Revoke consent for this session? Study material derived " +
    "from it will be deleted.",
  revokeAllConfirm:
    "[PLACEHOLDER] Revoke consent for ALL sessions? Study material derived " +
    "from them will be deleted.",
};
